module.exports = __webpack_public_path__ + "blissweb-bd.1e7a0f46431dddf64d7a.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/BlissWeb-Bd/blissweb-bd.eot
// module id = 153
// module chunks = 5